module.exports = __webpack_public_path__ + "static/img/report3d_function01.fbd290aa.png";